import {Component, Inject, OnInit, DOCUMENT, ChangeDetectionStrategy} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {bufferTime, filter, map} from 'rxjs/operators';
import {BehaviorSubject, firstValueFrom} from 'rxjs';
import { SettingsStore } from '../../../settings/store/settings-store.service';
import {AuthService} from "@auth0/auth0-angular";


@Component({
    selector: 'app-top-nav',
    templateUrl: './top-nav.component.html',
    styleUrls: ['./top-nav.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderComponent implements OnInit {
    userNameClick$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    navItems = [
        {
            title: 'Dashboard',
            icon: '/assets/img/topnav/mercatus-dashboard.svg',
            link: '/dashboard',
            baseLink: '/dashboard',
            active: true
        },
        {
            title: 'Veranstaltungen',
            icon: '/assets/img/topnav/mercatus-events.svg',
            link: '/veranstaltungen/all',
            baseLink: '/veranstaltungen',
            active: false,
            items: [
                {
                    title: 'Alle Veranstaltungen',
                    link: '/veranstaltungen/all',
                    active: false
                },
                {
                    title: 'Neu erstellen',
                    link: '/veranstaltungen/mutate/new',
                    iconClass: 'fa fa-plus',
                    active: false
                },
            ]

        },
        {
            title: 'Kontakte',
            icon: '/assets/img/topnav/mercatus-contacts.svg',
            link: '/kontakte',
            baseLink: '/kontakte',
            active: false,
            items: [
                {
                    title: 'Alle Kontakte',
                    link: '/kontakte',
                    active: false,
                },
                {
                    title: 'Neu erstellen',
                    link: '/kontakte/new',
                    iconClass: 'fa fa-plus',
                    active: false,
                },
            ]
        },
        {
            title: 'Einstellungen',
            icon: '/assets/img/topnav/mercatus-settings.svg',
            link: '/settings/bedarfe',
            baseLink: '/settings',
            active: false
        },
    ];

    get user$() {
        return this.auth.user$;
    }

    constructor(@Inject(DOCUMENT) private document: any, private readonly auth: AuthService, private router: Router, private settingsStore: SettingsStore) {
        firstValueFrom(this.auth.isAuthenticated$).then(isAuthenticated => {
            if (!isAuthenticated) {
                return;
            }
            this.settingsStore.get().subscribe((settingsState) => {
                if (settingsState.settings.abacusSettings?.contactsManagedByAbacus == true) {
                    this.navItems.find(i => i.title === "Kontakte").items.pop();
                }
            });
        });
    }


    ngOnInit() {
        this.userNameClick$
            .pipe(
                bufferTime(2000, null, 3),
                map(list => list.length),
                filter(x => x >= 3)
            )
            .subscribe(() => {
                this.router.navigate(['/admin/userinfo']);
            });

        this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((navEnd: NavigationEnd) => {
            this.navItems.forEach(item => {
                item.items?.forEach(subItem => {
                    subItem.active = subItem.link === navEnd.url;
                });
                item.active = navEnd.url.includes(item.baseLink);
            });

            this.navItems = [...this.navItems];
        });
    }

    logout() {
        this.auth.logout({logoutParams: {returnTo: this.document.location.origin}});
    }
}
